export default {
  ROOT: '/',
  PROJECTS: '/projects',
  FITOUT: '/fit-out',
  PROJECT: '/project/:id',
  CONTACT: '/contact',
};
